<template>
    <div class="page page-home">
        <ul class="nav nav-tabs nav-justified elegant-color-dark">
            <li class="nav-item">
                <router-link to="/license" active-class="active" class="nav-link">Get License</router-link>
            </li>
            <li class="nav-item">
                <router-link to="/advantages" active-class="active" class="nav-link">What you get</router-link>
            </li>
        </ul>
        <div class="tab-content grey darken-3 card">
            <div class="tab-pane in" :class="{active: active_tab == 'license'}" id="tab_license" role="tabpanel">
                <div v-if="loading">
                    <div class="text-center pb-5 pt-5">
                        <font-awesome-icon :icon="['fas', 'sync']" :spin="true" :size="'8x'" />
                        <br />
                        <span class="mt-5 inline-block" style="font-size: 30px;">Processing payment...</span>
                    </div>
                </div>
                <div v-else-if="payment_error">
                    <div class="alert alert-danger mt-3" role="alert">
                        <p class="no-margin">{{payment_error}}</p>
                    </div>

                    <button type="button" v-on:click="goBack" class="btn btn-lg elegant-color-dark"><font-awesome-icon :icon="['fas', 'arrow-left']" />&nbsp;&nbsp;Back</button>
                </div>
                <div :class="{hidden: loading || payment_error}">
                    <div v-if="payment_step == 1">
                        <form v-on:submit.prevent="submitForm" id="payment_form">
                            <div class="row">
                                <div class="col-md-3 text-center">Price: <span class="text-success text-mono">&euro;4.99</span></div>
                                <div class="col-md-3 text-center">Users: <span class="text-success text-mono">1</span></div>
                                <div class="col-md-3 text-center">Browsers: <span class="text-success text-mono">Unlimited</span></div>
                                <div class="col-md-3 text-center">Duration: <span class="text-success text-mono">Forever</span></div>
                            </div>
                            <div class="md-form">
                                <input type="text" id="name" v-model="payment_data.name" class="form-control text-white" required>
                                <label for="name">Name</label>
                            </div>

                            <div class="md-form">
                                <input type="email" id="email" v-model="payment_data.email" class="form-control text-white" required>
                                <label for="email">Email</label>
                            </div>
                            <div class="mt-3 text-center">
                                <!--<button type="submit" class="btn btn-lg elegant-color-dark"><font-awesome-icon :icon="['fab', 'paypal']" :size="'sm'" />&nbsp;&nbsp;Pay with PayPal</button>-->

                                <div id="paypal-button-holder"></div>

                            </div>
                            <div class="mt-5 small">
                                <hr />
                                <span>Privacy policy:</span>
                                <ul class="list-unstyled mt-2 privacy-policy">
                                    <li><font-awesome-icon :icon="['fas', 'info-circle']" />&nbsp;&nbsp;Name and email from the above form will be shown on the license. The data will also be stored on the server in order to recover the license in case of lost.</li>
                                    <li><font-awesome-icon :icon="['fab', 'paypal']" />&nbsp;&nbsp;When paying with PayPal, your personal data from it (first and last name, email, address and phone) will be sent to Fake Data server.</li>
                                    <li><font-awesome-icon :icon="['fas', 'handshake']" />&nbsp;&nbsp;If you complete the purchase, you automatically agree with all of the above.</li>
                                </ul>

                                <span class="mt-4">Support:</span>
                                <ul class="list-unstyled mt-2 privacy-policy">
                                    <li><font-awesome-icon :icon="['fas', 'envelope']" />&nbsp;&nbsp;For any question you have, send an email at <a href="mailto:frustrations@haterapps.com" class="text-white">frustrations@haterapps.com</a></li>
                                </ul>
                            </div>
                        </form>
                    </div>
                    <div v-else-if="payment_step == 2">
                        <div class="mb-4 mt-3 h4 text-center text-success">Thank you for your financial support!</div>
                        <p>Below is your license for Fake Data extension. You can use it with as many browsers and devices as you want.</p>
                        <p>In case of lost, send an email to <a href="mailto:frustrations@haterapps.com" class="text-white">frustrations@haterapps.com</a> and you will get it back.</p>

                        <div class="md-form unique-textarea mt-5 text-mono">
                            <font-awesome-icon :icon="['fas', 'key']" :class="['prefix', 'grey-text']" :size="'sm'" />
                            <textarea type="text" id="license_key" class="form-control md-textarea text-white" rows="4" v-model="payment_response.data.license_key" readonly></textarea>
                            <label for="license_key">License Key</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane in" :class="{active: active_tab == 'advantages'}" id="tab_advantages" role="tabpanel">

                <p class="h5 text-white mt-4 mb-3">Why purchase Pro?</p>
                <ul class="mb-5">
                    <li>You get some pretty cool features. See the table below.</li>
                    <li>You want to get shit done immediately without writing JavaScript code over and over.</li>
                    <li>You will be able to write your code in an actual code editor, not in a lame <code>&lt;textarea&gt;</code>.</li>
                    <li>You support a tool that you probably use on a regular basis.</li>
                    <li>It's a one time payment and you can use it on as many browsers as you want, forever.</li>
                    <li>It's cheap. It's even less than a gram of weed, or so I've heard. </li>
                </ul>

                <div class="card card-cascade narrower elegant-color-dark">

                    <div class="view view-cascade gradient-card-header text-center dark-gradient narrower py-3 mx-4 mb-3">
                        <span class="white-text mx-3">Basic vs. Pro</span>
                    </div>

                    <div class="px-4">
                        <div class="table-wrapper">
                            <table class="table table-hover mb-0 table_free_vs_pro">
                                <thead>
                                <tr>
                                    <th class="th-lg">Feature</th>
                                    <th class="">Basic Version</th>
                                    <th class="">Pro Version</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr>
                                    <td>Regular updates with bug fixes and new features</td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Create unlimited Custom Generators</td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Use RegEx with Unnamed Fields</td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Use Custom Code with Generators</td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Use Custom Code with Fields</td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Backup &amp; Restore data</td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Manage global behavior of text inputs, checkboxes and &lt;select&gt; elements</td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Manage individual &lt;select&gt; elements on web pages</td>
                                    <td><font-awesome-icon :icon="['fas', 'times']" :class="['text-danger']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Manage individual checkboxes and radio buttons on web pages</td>
                                    <td><font-awesome-icon :icon="['fas', 'times']" :class="['text-danger']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Powerful code editor with syntax highlight</td>
                                    <td><font-awesome-icon :icon="['fas', 'times']" :class="['text-danger']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Advanced settings and customisations for each Generator</td>
                                    <td><font-awesome-icon :icon="['fas', 'times']" :class="['text-danger']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Advanced settings and customisations for each Field</td>
                                    <td><font-awesome-icon :icon="['fas', 'times']" :class="['text-danger']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Custom Code callbacks before and after inserting data</td>
                                    <td><font-awesome-icon :icon="['fas', 'times']" :class="['text-danger']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Import and use your own JavaScript libraries</td>
                                    <td><font-awesome-icon :icon="['fas', 'times']" :class="['text-danger']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Custom integration with third party libraries and Google Sheets</td>
                                    <td><font-awesome-icon :icon="['fas', 'times']" :class="['text-danger']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                <tr>
                                    <td>Enable Fake Data public API for using with UI test frameworks</td>
                                    <td><font-awesome-icon :icon="['fas', 'times']" :class="['text-danger']" /></td>
                                    <td><font-awesome-icon :icon="['fas', 'check']" :class="['text-success']" /></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .privacy-policy {
        line-height: 25px;
    }

    .dark-gradient {
        background: linear-gradient(40deg,#757575,#424242);
    }

    .table_free_vs_pro td,
    .table_free_vs_pro th {
        border-color: #424242;
    }

    @media (max-width: 991px) {
        .text-logo {
            font-size: 80px;
        }
    }
</style>

<script>
	export default {
		name: 'home',
		components: {},
		data() {
			return {
				active_tab: this.$route.params.kind || null,
				payment_step: 1,
                payment_data: {
					name: '',
                    email: '',
                    service: 'paypal'
                },
                payment_response: null,
                payment_error: null,
                loading: false
			}
		},
		watch: {
			'$route': function () {
				this.active_tab = this.$route.params.kind || null;

				this.resetBsEvents();
			},
			active_tab: {
				immediate: true,
				handler: function () {
					if (!this.active_tab) {
						this.changeTab('license');
						return;
					}
				}
			},
            payment_step: function() {
                this.resetBsEvents();
            }
		},
        mounted: function() {
			window.vue = this;
			this.resetBsEvents();
        },
		methods: {
			changeTab: function(tab_name) {
				this.active_tab = tab_name;
				this.$router.push({path: '/' + tab_name});
			},
			submitForm: function() {
				if (this.payment_data.name && this.payment_data.email && this.payment_data.service && $('#payment_form').get(0).checkValidity()) {
					setTimeout(function() {
						this.tryPayment();
					}.bind(this), 100);
				}
            },
            resetBsEvents: function() {
				this.$nextTick(function() {
					if (window.Waves && window.Waves.attach) {
						var input_selector = ['text', 'password', 'email', 'url', 'tel', 'number', 'search', 'search-md'].map(function (selector) {
							return 'input[type=' + selector + ']';
						}).join(', ') + ', textarea';


						$(input_selector).each(function (index, input) {
							var $input = $(this);
							var $labelAndIcon = $input.siblings('label, i, svg');
							var hasValue = $input.val().length;
							var hasPlaceholder = $input.attr('placeholder');
							// let isValid     = $input.validity.badInput === true;
							var addOrRemove = (hasValue || hasPlaceholder ? 'add' : 'remove') + 'Class';

							$labelAndIcon[addOrRemove]('active');
						});

						Waves.attach('.btn:not(.btn-flat), .btn-floating', ['waves-light']);
						Waves.attach('.btn-flat', ['waves-effect']);
						Waves.attach('.waves-light', ['waves-light']);
						Waves.attach('.navbar-nav a:not(.navbar-brand), .nav-icons li a, .navbar input', ['waves-light']);
						Waves.attach('.nav-tabs .nav-item:not(.dropdown)', ['waves-light']);

						this.showPayPalButton();
					}
                })
            },

            showPayPalButton: function() {
				this.$nextTick(function() {
					if ($('#paypal-button-holder').length && $('#paypal-button-holder').is(':empty')) {
						var self = this;
						paypal.Button.render({
							// env: 'sandbox',
							env: 'production',

							client: {
								// sandbox:    'AXAodQR7G5YFtBFBWOzV_kq3b7z_eNmhgpPvuNYwXHLzi_R4H3fhABuMlYb2HqbPX3OYbK-XE_ofQDFa',
								production: 'ASKtViQTYzQBogFg9pqh90tbfffXDPPR1l0xsiWBJv0S-c34EosJ9RHZnLw4-K9nxFEuWR-6TEmyONA4'
							},

							commit: true,

							style: {
								label: 'paypal',
								size:  'large',    // small | medium | large | responsive
								shape: 'rect',     // pill | rect
								color: 'black',     // gold | blue | silver | black
								tagline: false
							},

							payment: function(data, actions) {

								return actions.payment.create({
									payment: {
										transactions: [
											{
												amount: { total: '4.99', currency: 'EUR' }
											}
										]
									}
								});

							},

							onAuthorize: function(data, actions) {
								/*
                                 * Execute the payment here
                                 */

								return actions.payment.get().then(function(paymentDetails) {

									// Show a confirmation using the details from paymentDetails
									// Then listen for a click on your confirm button
                                    console.log(paymentDetails);

                                    if (paymentDetails.state == 'created') {
	                                    self.tryPayment(paymentDetails, function(data) {
		                                    return actions.payment.execute().then(function(confirmationDetails) {
		                                    	console.log(confirmationDetails);
		                                    	if (confirmationDetails.state == 'approved') {
				                                    $.ajax({
					                                    url: 'https://fakedata.haterapps.com/api/',
					                                    dataType: 'json',
					                                    method: 'POST',
					                                    data: {
						                                    action: 'paypalcomplete',
						                                    paypal_id: confirmationDetails.id,
                                                            transaction: confirmationDetails
					                                    },
					                                    success: function(data) {
						                                    if (data.status == 'error') {
							                                    self.payment_error = data.message;
							                                    self.loading = false;
						                                    } else {
							                                    self.payment_response = data;
							                                    self.payment_step = 2;
							                                    self.loading = false;
						                                    }
					                                    }.bind(this),
					                                    error: function() {
						                                    this.payment_error = 'An error has occured';
					                                    }.bind(this)
				                                    });
                                                }
		                                    });
	                                    });
                                    }
								});
							},

							onCancel: function(data, actions) {
								/*
                                 * Buyer cancelled the payment
                                 */
							},

							onError: function(err) {
								/*
                                 * An error occurred during the transaction
                                 */
							}
						}, '#paypal-button-holder');
                    }
                })
            },

			tryPayment: function(paymentDetails, callback) {
				this.loading = true;
				$.ajax({
                    url: 'https://fakedata.haterapps.com/api/',
                    dataType: 'json',
                    method: 'POST',
                    data: {
                        action: 'payattempt',
                        name: this.payment_data.name,
	                    email: this.payment_data.email,
	                    service: this.payment_data.service,
                        paypal_id: paymentDetails.id
                    },
                    success: function(data) {
                        if (data.status == 'error') {
	                        this.payment_error = data.message;
                        	this.loading = false;
                        } else {
                        	if (typeof callback == 'function') {
                        		callback(data);
                            }
                        }
                    }.bind(this),
                    error: function() {
                    	this.payment_error = 'An error has occured';
                    }.bind(this)
                });
            },

			goBack: function() {
				this.payment_error = null;
				this.payment_step = 1;
			}
		},
	}
</script>
